import { AxiosService } from './axios.service'

/**
 * Defines the API methods for a city
 */
export default class CityService {
	static baseURL = 'cidade'

	/**
	 * Searches the city
	 * @return {Promise<any[]>} List of cities
	 */
	static search(params) {
		return AxiosService.get(`${CityService.baseURL}/buscar`, { params }).then(
			({ data }) => data
		)
	}
}
